import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

type AddSectionButtonProps = {
  onClick: () => void;
};

const AddSectionButton = ({ onClick }: AddSectionButtonProps) => {
  return (
    <Button
      variant="outline"
      className="w-full border-dashed border-2 py-8 mt-4"
      onClick={onClick}
    >
      <Plus className="h-5 w-5 mr-2" />
      Add New Section
    </Button>
  );
};

export default AddSectionButton;
